module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('app-loading') : _c('div', [_c('div', {
    staticClass: "intro-y flex flex-col-reverse sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex"
  })]), _vm._v(" "), _c('div', {
    staticClass: "intro-y col-span-12 overflow-auto lg:overflow-visible"
  }, [_c('table', {
    staticClass: "table table-report -mt-2"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("NOMBRE")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("CORREO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("EQUIPO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-nowrap"
  }, [_vm._v("ACTIVIDAD")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-nowrap"
  }, [_vm._v("ACCIONES")])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "intro-x"
  }, [_c('td', {
    staticClass: "Text-center"
  }, [_c('div', {
    staticClass: "text-center text-gray-600 text-xs whitespace-no-wrap"
  }, [_vm._v("\n                " + _vm._s(_vm.activity.user.name) + "\n              ")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "text-center text-gray-600 text-xs whitespace-no-wrap"
  }, [_vm._v("\n                " + _vm._s(_vm.activity.user.email) + "\n              ")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "text-center text-gray-600 text-xs whitespace-no-wrap"
  }, [_vm._v("\n                " + _vm._s(_vm.activity.user.team ? _vm.activity.user.team.name : '-') + "\n              ")])]), _vm._v(" "), _c('td', {
    staticClass: "w-40"
  }, [_c('div', {
    staticClass: "text-center text-gray-600 text-xs whitespace-no-wrap"
  }, [_vm._v("\n                " + _vm._s(_vm.activity.activity.name) + "\n              ")])]), _vm._v(" "), _c('td', {
    staticClass: "table-report__action w-56"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('router-link', {
    staticClass: "flex mx-auto items-center p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
    attrs: {
      "to": ("/admin/activities/" + (_vm.activity.activity.slug) + "/participations")
    }
  }, [_vm._v("\n                  Regresar\n                ")])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('table', {
    staticClass: "table table-report -mt-2"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("PREGUNTA")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("RESPUESTA")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.activity.answers), function(answer) {
    return _c('tr', {
      key: ("activity-" + (answer.slug)),
      staticClass: "intro-x"
    }, [_c('td', {
      staticClass: "w-40 text-center"
    }, [(answer.question) ? _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(answer.question.title) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [(answer.question_answer) ? _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap",
      class: answer.is_correct ? 'text-green-400' : 'text-red-400'
    }, [_vm._v("\n                " + _vm._s(answer.question_answer.text_answer) + "\n              ")]) : _vm._e()])])
  }), 0)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-290a6d6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/activity/ListUserAnswers.vue
// module id = 424
// module chunks = 1